/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, RequestResult } from '#shared/api/client'
import type { LogoutOptions, LogoutResponses } from '../models/Logout'
import { client } from '#shared/api/client'

/**
 * @description The removal cookie stays even though `Clear-Site-Data` asks for the
 * cookies as well: a browser that does not implement the header — and it is
 * not universal — has only the removal cookie to go on, and the two say the
 * same thing.
 * @summary Ends the session the cookie names and clears the cookie. Idempotent and
 * never a 401: a browser holding an expired or already revoked cookie is
 * asking to forget it, and the answer to that is yes.
 * {@link /api/logout}
 */
export function logout<ThrowOnError extends boolean = true>(options: Options<LogoutOptions, ThrowOnError> = {}): Promise<RequestResult<LogoutResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return request({ method: 'POST', url: '/api/logout', ...config, throwOnError: config.throwOnError ?? true }) as Promise<RequestResult<LogoutResponses, ThrowOnError>>
}
